(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbn-entry-splash"]) return;
  try {
    
(() => {
  const setup = (root) => {
    if (!root || root.dataset.mbnEntryReady === 'true') return;
    root.dataset.mbnEntryReady = 'true';
    document.documentElement.classList.add('mbn-entry-lock');

    let closed = false;
    let timer;

    const close = () => {
      if (closed) return;
      closed = true;
      window.clearTimeout(timer);
      root.classList.add('is-striking');
      window.setTimeout(() => {
        root.classList.add('is-leaving');
        document.documentElement.classList.remove('mbn-entry-lock');
        window.setTimeout(() => root.remove(), 560);
      }, 190);
    };

    root.addEventListener('click', close);
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Escape') {
        event.preventDefault();
        close();
      }
    });

    timer = window.setTimeout(close, 5000);
  };

  const init = () => document.querySelectorAll('[data-mbn-entry]').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once:true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbn-global-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const buildLocalizedUrl = (languageCode) => {
    const knownLocales = ['ar', 'de', 'es', 'fa', 'fr', 'nl'];
    let path = window.location.pathname || '/';
    const localePattern = new RegExp('^/(' + knownLocales.join('|') + ')(?=/|$)', 'i');
    path = path.replace(localePattern, '');
    if (!path.startsWith('/')) path = '/' + path;
    if (path === '') path = '/';

    let localizedPath = path;
    if (languageCode !== 'en') {
      localizedPath = '/' + languageCode + (path === '/' ? '/' : path);
    }

    return localizedPath + window.location.search + window.location.hash;
  };

  const initMenus = () => {
    document.querySelectorAll('.mbn-header').forEach((header) => {
      if (header.dataset.mbnMenuReady === 'true') return;
      const toggle = header.querySelector('.mbn-mobile-menu__toggle');
      const panel = header.querySelector('.mbn-mobile-menu__panel');
      const backdrop = header.querySelector('.mbn-mobile-menu__backdrop');
      const close = header.querySelector('.mbn-mobile-menu__close');
      if (!toggle || !panel || !backdrop || !close) return;

      header.dataset.mbnMenuReady = 'true';

      const setOpen = (open) => {
        header.classList.toggle('mbn-menu-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        document.body.classList.toggle('mbn-menu-lock', open);
        if (!open) {
          panel.querySelectorAll('details[open]').forEach((item) => item.removeAttribute('open'));
        }
      };

      toggle.addEventListener('click', () => {
        setOpen(!header.classList.contains('mbn-menu-open'));
      });

      backdrop.addEventListener('click', () => setOpen(false));
      close.addEventListener('click', () => setOpen(false));

      const languageForm = header.querySelector('#MBNMobileLocalizationForm');
      if (languageForm && languageForm.dataset.mbnLanguageReady !== 'true') {
        languageForm.dataset.mbnLanguageReady = 'true';
        const languageInput = languageForm.querySelector('[data-mbn-language-input]');
        const languagePicker = languageForm.querySelector('.mbn-mobile-lang-picker');
        if (languagePicker) {
          languagePicker.addEventListener('toggle', () => {
            header.classList.toggle('mbn-language-open', languagePicker.open);
          });
        }
        languageForm.querySelectorAll('[data-mbn-language-code]').forEach((button) => {
          button.addEventListener('click', () => {
            const languageCode = button.dataset.mbnLanguageCode;
            if (!languageInput || !languageCode) return;
            if (languageInput.value === languageCode) {
              const picker = button.closest('.mbn-mobile-lang-picker');
              if (picker) picker.removeAttribute('open');
              header.classList.remove('mbn-language-open');
              return;
            }
            languageInput.value = languageCode;
            const picker = button.closest('.mbn-mobile-lang-picker');
            if (picker) picker.removeAttribute('open');
            header.classList.remove('mbn-language-open');
            window.location.assign(buildLocalizedUrl(languageCode));
          });
        });
      }

      const desktopLanguageSelect = header.querySelector('[data-mbn-language-select]');
      if (desktopLanguageSelect && desktopLanguageSelect.dataset.mbnLanguageReady !== 'true') {
        desktopLanguageSelect.dataset.mbnLanguageReady = 'true';
        desktopLanguageSelect.addEventListener('change', () => {
          if (!desktopLanguageSelect.value) return;
          window.location.assign(buildLocalizedUrl(desktopLanguageSelect.value));
        });
      }

      panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) setOpen(false);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && header.classList.contains('mbn-menu-open')) {
          setOpen(false);
          toggle.focus();
        }
        const languagePicker = header.querySelector('.mbn-mobile-lang-picker');
        if (event.key === 'Escape' && languagePicker && languagePicker.open) {
          languagePicker.removeAttribute('open');
          header.classList.remove('mbn-language-open');
        }
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth > 1100 && header.classList.contains('mbn-menu-open')) {
          setOpen(false);
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenus, { once: true });
  } else {
    initMenus();
  }
  document.addEventListener('shopify:section:load', initMenus);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbn-offers"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-mbn-reward-system]');
  if (!root) return;

  const country = (root.dataset.country || '').toUpperCase();
  const eligibleCountry = country === 'NL' || country === 'BE';
  const threshold = Number(root.dataset.threshold || 25000);
  const gifts = [
    { id: Number(root.dataset.shakerVariant), type: 'shaker' },
    { id: Number(root.dataset.creatineVariant), type: 'creatine' }
  ];
  const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let syncing = false;
  let queued = false;

  const getCart = async () => {
    const response = await fetch(cartRoot + 'cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  };

  const giftType = (item) => {
    if (!item || !item.properties) return '';
    return item.properties._mbn_gift || '';
  };

  const hasDiscountCode = (cart) => {
    const directCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
    if (directCodes.some((entry) => {
      if (typeof entry === 'string') return entry.trim().length > 0;
      return entry && typeof entry.code === 'string' && entry.code.trim().length > 0;
    })) return true;

    const applications = [];
    if (Array.isArray(cart.discount_applications)) applications.push(...cart.discount_applications);
    if (Array.isArray(cart.cart_level_discount_applications)) applications.push(...cart.cart_level_discount_applications);

    if (Array.isArray(cart.items)) {
      cart.items.forEach((item) => {
        if (!Array.isArray(item.discount_allocations)) return;
        item.discount_allocations.forEach((allocation) => {
          if (allocation && allocation.discount_application) applications.push(allocation.discount_application);
        });
      });
    }

    return applications.some((application) => {
      const type = String(application && (application.type || application.discount_type || '')).toLowerCase();
      return type === 'discount_code' || type === 'code';
    });
  };

  const eligibleSubtotal = (cart) =>
    cart.items.reduce((sum, item) => {
      return giftType(item) ? sum : sum + Number(item.original_line_price || item.line_price || 0);
    }, 0);

  const refreshCartUI = () => {
    if (window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
      window.location.reload();
      return;
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mbn-reward-system' });
    }
  };

  const applyUpdates = async (updates) => {
    if (!Object.keys(updates).length) return false;
    const response = await fetch(cartRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates })
    });
    if (!response.ok) throw new Error('Cart update failed');
    await response.json();
    return true;
  };

  const addMissingGifts = async (missing) => {
    if (!missing.length) return false;
    const response = await fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: missing.map((gift) => ({
          id: gift.id,
          quantity: 1,
          properties: { _mbn_gift: gift.type }
        }))
      })
    });
    if (!response.ok) throw new Error('Gift add failed');
    await response.json();
    return true;
  };

  const sync = async () => {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;
    try {
      const cart = await getCart();
      const base = eligibleSubtotal(cart);
      const giftLines = cart.items.filter((item) => giftType(item));
      const discountCodeActive = hasDiscountCode(cart);
      let changed = false;

      if (!eligibleCountry || base < threshold || discountCodeActive) {
        const updates = {};
        giftLines.forEach((item) => { updates[item.key] = 0; });
        changed = await applyUpdates(updates);
      } else {
        const updates = {};
        const seen = new Set();

        giftLines.forEach((item) => {
          const type = giftType(item);
          if (!gifts.some((gift) => gift.type === type)) {
            updates[item.key] = 0;
            return;
          }
          if (seen.has(type)) {
            updates[item.key] = 0;
            return;
          }
          seen.add(type);
          if (item.quantity !== 1) updates[item.key] = 1;
        });

        if (Object.keys(updates).length) {
          changed = await applyUpdates(updates) || changed;
        }

        const latest = changed ? await getCart() : cart;
        const latestTypes = new Set(latest.items.map(giftType).filter(Boolean));
        const missing = gifts.filter((gift) => !latestTypes.has(gift.type));
        if (missing.length) {
          changed = await addMissingGifts(missing) || changed;
        }
      }

      if (changed) refreshCartUI();
    } catch (error) {
      console.error('MBN rewards sync:', error);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        setTimeout(sync, 120);
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => setTimeout(sync, 120));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event && event.source === 'mbn-reward-system') return;
      setTimeout(sync, 180);
    });
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('#cart-icon-bubble, [name="checkout"], cart-remove-button')) {
      setTimeout(sync, 220);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="updates[]"], .quantity__input')) {
      setTimeout(sync, 350);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbn-whatsapp-float"]) return;
  try {
    
(() => {
  const links = document.querySelectorAll('[data-mbn-whatsapp-link]');
  if (!links.length) return;

  const buildMessage = () => {
    const lang = (document.documentElement.lang || 'en').toLowerCase();
    const title = document.title.replace(/\s+[–—-]\s+.*$/, '').trim();
    const url = window.location.href;

    let prefix = 'Hello MBN, I have a question about this page:';
    if (lang.startsWith('nl')) prefix = 'Hallo MBN, ik heb een vraag over deze pagina:';
    if (lang.startsWith('fa')) prefix = 'سلام MBN، درباره این صفحه سوال دارم:';
    if (lang.startsWith('ar')) prefix = 'مرحباً MBN، لدي سؤال حول هذه الصفحة:';

    return prefix + '\n' + title + '\n' + url;
  };

  const updateLinks = () => {
    const href = 'https://wa.me/31634330509?text=' + encodeURIComponent(buildMessage());
    links.forEach((link) => link.setAttribute('href', href));
  };

  updateLinks();
  window.addEventListener('pageshow', updateLinks);
  document.addEventListener('shopify:section:load', updateLinks);
})();

  } catch(e) { console.error(e); }
})();
})();
